import { render, staticRenderFns } from "./InternalServerError.vue?vue&type=template&id=65ef0798&"
import script from "./InternalServerError.vue?vue&type=script&lang=ts&"
export * from "./InternalServerError.vue?vue&type=script&lang=ts&"
import style0 from "./InternalServerError.vue?vue&type=style&index=0&id=65ef0798&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports